export const ENGLISH_COURSE_ID = 3
export const SUPPORT_TELEGRAM_URL = 'https://t.me/uni_ai_ed'
export const SUPPORT_MAX_URL =
  'https://max.ru/u/f9LHodD0cOITeTRnVsR6z516qqw2213uh5uiQr3kYVQ5qbMaQ6HP6bH46c8'
